import { datadogRum } from '@datadog/browser-rum';
import { datadogConfig } from '@/config/datadog';
import logger from '@/services/logger';

export interface RumIdentity {
  sub: string;
  name?: string;
  email?: string;
  role?: string;
}

export default {
  install: () => {
    if (!datadogConfig) return;

    try {
      datadogRum.init(datadogConfig);
    } catch (initError) {
      logger.warn('Datadog RUM: failed to initialize', initError);
    }
  },
};

// setUser REPLACES the whole user object, so exactly one caller may own the identity: a
// second call with a narrower object silently drops whatever the first one set.
//
// `name` is what Datadog labels the session with — without it the session list reads
// "Public User" however complete the rest of the identity is.
export function identifyRumUser(identity: RumIdentity): void {
  if (!datadogConfig) return;

  try {
    datadogRum.setUser({ id: identity.sub, name: identity.name, email: identity.email, role: identity.role });
  } catch (identifyError) {
    logger.warn('Datadog RUM: failed to set the user', identifyError);
  }
}

export function clearRumUser(): void {
  if (!datadogConfig) return;

  try {
    datadogRum.clearUser();
  } catch (clearError) {
    logger.warn('Datadog RUM: failed to clear the user', clearError);
  }
}
